import React from 'react';
import useTrack from '../../../src/hooks/useTrack/useTrack';
import AudioTrack from '../AudioTrack/AudioTrack';
import VideoTrack from '../VideoTrack/VideoTrack';
import DataTrack from '../DataTrack/DataTrack';
export default function Publication({ publication, kind, isLocal, disableAudio, videoPriority, }) {
    const track = useTrack(publication);
    switch (kind) {
        case 'video':
            return (React.createElement(VideoTrack, { track: track, priority: videoPriority, isLocal: isLocal }));
        case 'audio':
            return (!disableAudio && track) ? React.createElement(AudioTrack, { track: track }) : null;
        case 'data':
            return track ? React.createElement(DataTrack, { track: track }) : null;
        default:
            return null;
    }
}
//# sourceMappingURL=Publication.js.map